export const serviceDescriptionColumns = [
  {
    title: 'Service Description',
    key: 'description',
    dataIndex: 'description'
  }
];
